<template>
    <div v-if="stop_reason">
        <el-button  @click="openHistories" :class="' result ' +resultClass[stop_reason]">{{' '+redirections}}</el-button>
        <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
			<el-steps direction="vertical" >
				<el-step class="step" v-for="(v,k) in histories" :title="v" :key="k" :status="getStatus(k)"></el-step>
			</el-steps>
		</el-dialog>
    </div>
</template>

<script>
export default {
    
	data(){
		return {
			resultClass:{
				"reach store":"el-icon-success status-active",
				"reach the end page":"el-icon-question",
				"internal error":"el-icon-error status-warning",
				"back to ourself":"el-icon-warning status-paused",
			},
			dialogVisible:false,
		}
	},
	props:{
		stop_reason:String,
		redirections:Number,
		histories:Array,
	},
	methods:{
		openHistories(){
			if(this.histories){
				this.dialogVisible = true;
			}
		},
		getStatus(k){
			let status = k%2===0?'process':'finish';
			if(k===this.histories.length-1){
				if(this.stop_reason==='reach store'){
					status='success'
				}else if(this.stop_reason==='internal error'){
					status='error'
				}
			}
			return status;

		},
	}
}
</script>
<style scoped>
.result{
	font-size: 16px;
}
.step {
	word-break: break-all;
}
</style>